<template>
  <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M29.25 4.5H13.5C12.3065 4.5 11.1619 4.97411 10.318 5.81802C9.47411 6.66193 9 7.80653 9 9V45C9 46.1935 9.47411 47.3381 10.318 48.182C11.1619 49.0259 12.3065 49.5 13.5 49.5H40.5C41.6935 49.5 42.8381 49.0259 43.682 48.182C44.5259 47.3381 45 46.1935 45 45V20.25L29.25 4.5Z" stroke="#233780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M29.25 4.5V20.25H45" stroke="#233780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'DocumentIcon'
}
</script>
